import React, { useContext, useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { isEqual } from 'lodash';

import BasicForm, { UserProps } from '@/operator/utils/forms/BasicForm';

import EditUserContext from '../../context/EditUserContext';
import EditUserActions from '../Actions/index';

const EditUserBasicInformation: React.FC = () => {
    const {
        localUpdatedUser,
        setLocalUpdatedUser,
        fetchedQualityUser: user,
        updateUserBasicInformation,
        enableButtons,
    } = useContext(EditUserContext);

    const [hasUserBeenUpdatedLocally, setHasUserBeenUpdatedLocally] =
        useState(false);

    // Note: we're using the following properties. The rest is not in use by Quality
    const fetchedUserValuesFromDB: UserProps = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        avatarUrl: user.photoURL,
        displayName: user.displayName,
        pronouns: user.pronouns,
    };

    const checkIfThereAnyNewUserChanges = (): boolean => {
        return !isEqual(fetchedUserValuesFromDB, localUpdatedUser);
    };

    const cancelChanges = () => {
        setLocalUpdatedUser(fetchedUserValuesFromDB);
    };

    useEffect(() => {
        const hasUserBeenUpdatedLocally = checkIfThereAnyNewUserChanges();
        setHasUserBeenUpdatedLocally(hasUserBeenUpdatedLocally);
    }, [localUpdatedUser]);

    return (
        <Container>
            {hasUserBeenUpdatedLocally && (
                <EditUserActions
                    onClickSaveChanges={() => updateUserBasicInformation()}
                    onClickCancelChanges={() => cancelChanges()}
                    disableButtons={!enableButtons}
                />
            )}

            <BasicForm
                onFormStateChanged={setLocalUpdatedUser}
                currentState={localUpdatedUser}
            />
        </Container>
    );
};

export default EditUserBasicInformation;
